/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const cronos_chain_about = () => `Cronos emerges as an interoperable blockchain, streamlining the migration of applications and crypto assets from various chains while prioritizing low transaction costs, rapid throughput, and fast finalization times. It operates as an Ethereum Virtual Machine (EVM)-compatible chain, augmented with support for Inter-Blockchain Communications (IBC) networks based on the Cosmos SDK. This integration empowers developers to create and launch dApps atop the EVM infrastructure.`
